module.exports = __webpack_public_path__ + "static/media/chevron-right.64883730.svg";